import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';

import {CommonService} from 'src/app/services/common.service';

@Component({
    selector: 'app-mapboxgl-search',
    templateUrl: './mapboxgl-search.component.html',
    styleUrls: ['./mapboxgl-search.component.scss'],
    providers: []
})
export class MapboxglSearchComponent implements OnInit {

    public items: any;
    public dataItems: any;
    public createForm: FormGroup;
    public itemModalOpen = false;
    public tables = [{value: 'watershed', text: 'Watershed'}, {
        value: 'floodprone',
        text: 'Floodprone'
    }, {value: 'subbasin', text: 'Sub-basins'}];
    public waterShedAttrs = [{value: 'runoff', text: 'Total runoff'}, {value: 'area', text: 'Area'}];
    public conditions = [{value: '>=', text: 'Greater than'}, {value: '<=', text: 'Less than'}];
    public floodProneAttrs = [{value: 'area', text: 'Area'}];
    public subBasinAttrs = [{value: 'subbasin', text: 'Sub-basin'}, {value: 'area', text: 'Area'}, {
        value: 'runoff',
        text: 'Runoff generated'
    }, {value: 'drain_cap', text: 'Drain capacity running through the subbasin'}];
    public subBasinFieldValues = [];

    constructor(
        public dialog: MatDialog,
        public formBuilder: FormBuilder,
        public commonService: CommonService,
        public dialogRef: MatDialogRef<any>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
    }

    ngOnInit(): void {
        this.formInit();
    }

    // Init form
    formInit(): void {
        this.createForm = this.formBuilder.group({
            TableName: ['watershed', [Validators.required]],
            fieldName: ['runoff', [Validators.required]],
            condition: ['>=', [Validators.required]],
            value: ['0', [Validators.required]],
        });

        this.createForm.controls.TableName.valueChanges.subscribe(async res => {
            if (res === 'watershed') {
                this.createForm.controls.value.setValue('0');
                this.createForm.controls.condition.setValue('>=');
                this.createForm.controls.fieldName.setValue(this.waterShedAttrs[0].value);
            }
            if (res === 'floodprone') {
                this.createForm.controls.value.setValue('0');
                this.createForm.controls.condition.setValue('>=');
                this.createForm.controls.fieldName.setValue(this.floodProneAttrs[0].value);
            }
            if (res === 'subbasin') {
                this.createForm.controls.fieldName.setValue(this.subBasinAttrs[0].value);
            }
        });

        this.createForm.controls.fieldName.valueChanges.subscribe(async res => {
            if (this.createForm.controls.TableName.value === 'subbasin') {
                if (res === this.subBasinAttrs[0].value) {
                    this.getDataByField().then();
                } else {
                    this.createForm.controls.value.setValue(0);
                    this.createForm.controls.condition.setValue(this.conditions[0].value);
                }
            }
        });
    }

    async getDataByField(): Promise<void> {
        const listValues = [];
        this.subBasinFieldValues = [{value: '', text: 'All'}];
        const fieldName = this.createForm.controls.fieldName.value;
        const response: any = await this.commonService.getDataByField({tableName: 'subbasin', field: fieldName});
        if (response.result) {
            // tslint:disable-next-line:prefer-for-of
            for (let index = 0; index < response.result.length; index++) {
                const res = response.result[index];
                listValues.push(res[fieldName]);
                this.subBasinFieldValues.push({value: `(${res[fieldName]})`, text: res[fieldName]});
            }
        }
        this.subBasinFieldValues[0].value = `(${listValues.join(',')})`;
        this.createForm.controls.condition.setValue('in');
        this.createForm.controls.value.setValue(this.subBasinFieldValues[0].value);
    }

    async onSubmit(): Promise<void> {
        if (this.createForm.valid === false) {
            return;
        }
        await this.getItems();
    }

    async searchByField(): Promise<void> {
        const response: any = await this.commonService.searchByFields(this.createForm.value);
        if (response.status) {
            this.items = {items: response.result, tableName: this.createForm.controls.TableName.value};
        }
    }

    async getItems(): Promise<void> {
        // Search data
        this.createForm.value.tableName = this.createForm.controls.TableName.value;
        const response: any = await this.commonService.searchByFields(this.createForm.value);
        if (response.status) {
            this.dataItems = {items: response.data, tableName: this.createForm.controls.TableName.value};
        }

        // Get extend and fitbound
        // const res: any = await this.commonService.getExtent({tableName: this.createForm.controls.TableName.value});
        // if (res.result && res.result[0]) {
        //     const extent = res.result[0].st_extent.replaceAll('BOX(', '').replaceAll(')', '').replaceAll(',', ' ').split(' ');
        //     this.data.service.fitBounds([[extent[0], extent[1]], [extent[2], extent[3]]]);
        // }

        // Hide all other layers
        this.data.service.layers.map(layer => {
            layer.display = layer.id === this.createForm.controls.TableName.value ? false : true;
            this.data.service.toggleShowLayer(layer.id);
        });

    }

    closeItems(): void {
        this.dataItems = {};
    }

    close(): void {
        // Show all layers
        this.data.service.layers.map(layer => {
            layer.display = false;
            this.data.service.toggleShowLayer(layer.id);
        });
        this.dialogRef.close();
    }

}
